import { useEffect } from "react";
import { isEmbedded } from "./EmbeddedLoginPoller";

export const parentOrigin = () => {
    if (window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0) {
        return window.location.ancestorOrigins[0];
    }
    try {
        return document.referrer ? new URL(document.referrer).origin : null;
    } catch (e) {
        return null;
    }
};

// When embedded, tell the parent page how tall the app is so its iframe can follow.
export default function useEmbedHeight() {
    useEffect(() => {
        if (!isEmbedded()) {
            return undefined;
        }

        const target = parentOrigin();
        if (!target) {
            return undefined;
        }

        let last = 0;
        let frame = 0;

        // The app is a fixed-height shell whose content scrolls inside a container, so the
        // content height is the viewport plus whatever the largest inner scroller overflows by.
        const measure = () => {
            let extra = 0;
            document.querySelectorAll("#app *").forEach((el) => {
                const overflow = el.scrollHeight - el.clientHeight;
                if (overflow > extra && /(auto|scroll)/.test(getComputedStyle(el).overflowY)) {
                    extra = overflow;
                }
            });
            return Math.ceil(Math.max(document.documentElement.scrollHeight, window.innerHeight + extra));
        };

        const send = () => {
            frame = 0;
            const value = measure();
            if (Math.abs(value - last) > 1) {
                last = value;
                window.parent.postMessage({ type: "oceanz:height", value }, target);
            }
        };
        const schedule = () => {
            if (!frame) {
                frame = requestAnimationFrame(send);
            }
        };

        const observer = new ResizeObserver(schedule);
        const mutations = new MutationObserver(schedule);
        observer.observe(document.documentElement);
        mutations.observe(document.getElementById("app") || document.body, { childList: true, subtree: true });
        window.addEventListener("load", schedule);
        schedule();

        return () => {
            observer.disconnect();
            mutations.disconnect();
            window.removeEventListener("load", schedule);
            cancelAnimationFrame(frame);
        };
    }, []);
}
